/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Save_Error_AlertInputs */

const en_job_form_save_error_alert = /** @type {(inputs: Job_Form_Save_Error_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error saving job posting.`)
};

const de_job_form_save_error_alert = /** @type {(inputs: Job_Form_Save_Error_AlertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Speichern der Stellenanzeige.`)
};

/**
* | output |
* | --- |
* | "Error saving job posting." |
*
* @param {Job_Form_Save_Error_AlertInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_save_error_alert = /** @type {((inputs?: Job_Form_Save_Error_AlertInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Save_Error_AlertInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_save_error_alert(inputs)
	return en_job_form_save_error_alert(inputs)
});